import bookingMultiComponent from './booking-multi.component';

const bookingMultiModule = angular
  .module('bookingMulti', [])
  .component('bookingMulti', bookingMultiComponent);

export default bookingMultiModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-multi/booking-multi.js
 **/